// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".policy-text[data-v-ca85c3de]{max-height:300px;overflow-y:auto}.title-left[data-v-ca85c3de]{display:flex;flex:1;align-items:center}.title-text[data-v-ca85c3de]{color:inherit;max-width:calc(100% - 250px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-right:14px;text-decoration:none}", ""]);
// Exports
module.exports = exports;
